// extracted by mini-css-extract-plugin
module.exports = {"hidden":"DarMode_hidden__j9D6U","darkMode":"DarMode_darkMode__pPrGc"};